import type { ReactNode } from "react";

import { DropdownDivider } from "../DropdownDivider";

import * as styles from "./DropdownHeader.styles";

interface Props {
  /**
   * Sets implementation of boilerplate styles
   *
   * @default false
   */
  noStyle?: boolean;
  /**
   * Allows for increased padding version
   *
   * @default false
   */
  isLargePadding?: boolean;
  /**
   * sets inclusion of divider between header and content
   *
   * @default: true
   */
  showDivider?: boolean;
  /**
   * The header content, most likely just some text
   *
   * @default undefined
   */
  children?: ReactNode;
}

const defaultProps = {
  noStyle: false,
  showDivider: true,
};

const DropdownHeader = ({ children, noStyle, isLargePadding, showDivider, ...rest }: Props) => {
  const conditionalStyles = [!noStyle && styles.dropdownHeader];

  const contentStyles = [
    !noStyle && styles.headerContent,
    isLargePadding && styles.largePadding,
    showDivider && styles.dividerShims,
  ];

  return (
    <div css={conditionalStyles} {...rest}>
      <div css={contentStyles}>{children}</div>
      {showDivider && <DropdownDivider hasTopMargin={false} />}
    </div>
  );
};

DropdownHeader.defaultProps = defaultProps;
export { DropdownHeader };
